'use strict';

var flex = {};

exports.__exports = flex;
//# sourceMappingURL=flex.cjs.map
